import { faPlusCircle, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

function Brands({
  brands = [],
  onChange,
  addBrand,
  removeBrand,
}) {
  
  const handleInputChange = (e, index, field) => {
    const updatedData = [...brands];
    updatedData[index][field] = e.target.value;
    onChange(updatedData);
  };

  const handleImageChange = (index, event) => {
  const file = event.target.files[0];
  if (file) {
    const updatedData = [...brands];
    updatedData[index].image = file;
    onChange(updatedData);
  }
};

const handleDragOver = (e, index) => {
  e.preventDefault();
  e.stopPropagation();
  // Optional: Add visual feedback for drag over
  e.currentTarget.parentElement.classList.add('border-blue-500', 'bg-blue-50');
};

const handleDragLeave = (e, index) => {
  e.preventDefault();
  e.stopPropagation();
  // Remove visual feedback
  e.currentTarget.parentElement.classList.remove('border-blue-500', 'bg-blue-50');
};

const handleDrop = (e, index) => {
  e.preventDefault();
  e.stopPropagation();
  
  // Remove visual feedback
  e.currentTarget.parentElement.classList.remove('border-blue-500', 'bg-blue-50');
  
  const files = e.dataTransfer.files;
  if (files.length > 0) {
    const file = files[0];
    
    // Check if it's an image file
    if (file.type.startsWith('image/')) {
      const updatedData = [...brands];
      updatedData[index].image = file;
      onChange(updatedData);
    } else {
      // Optional: Show error message for non-image files
      alert('Please select an image file');
    }
  }
};

  return (
    <div className="w-full mt-5">
      <div className="w-full">
        <div className="w-full flex flex-col justify-start items-center">
          <div className="w-full flex flex-col justify-start items-start">
            <div className="w-full container mx-auto px-4 mb-2">
              <table className="w-full">
                <thead>
                  <tr className="text-[#6c7184] bg-[#fafafc]">
                    <th className="font-semibold text-left text-sm py-2 px-2 border cursor-pointer border">Logo</th>
                    <th className="font-semibold text-left text-sm py-2 px-2 border cursor-pointer border">Name</th>
                    <th className="font-semibold text-left text-sm py-2 px-2 border cursor-pointer border">Video</th>
                  </tr>
                </thead>
                <tbody>
                    {(Array.isArray(brands) ? brands : []).map((brand, index) => (
                    <tr key={index}>
{/*                       <td className="text-xs border">
                        <input
                          type="text"
                          value={brand.image}
                          onChange={(e) => handleInputChange(e, index, 'image')}
                          className="outline-blue-500 text-sm w-full h-full p-2 bg-transparent rounded-md 
                                    hover:border-blue-500 hover:ring-1 hover:ring-blue-500 hover:ring-opacity-90"
                        />
                      </td> */}
                        <td className="border-t border-r border-b border-gray-200 p-2 text-center">
                        <div className="w-20 h-20 border-2 border-dashed border-gray-300 rounded-lg flex justify-center items-center relative mx-auto">
                          <input
                            type="file"
                            name="image"
                            accept="image/*"
                            id={`file-input-${index}`}
                            onChange={(e) => handleImageChange(index, e)}
                            onDragOver={(e) => handleDragOver(e, index)}
                            onDragLeave={(e) => handleDragLeave(e, index)}
                            onDrop={(e) => handleDrop(e, index)}
                            className="absolute inset-0 opacity-0 cursor-pointer"
                          />
                          <label htmlFor={`file-input-${index}`} className="cursor-pointer flex justify-center items-center w-full h-full">
                            {brand.image ? (
                              <img 
                                src={
                                      brand.image instanceof File
                                        ? URL.createObjectURL(brand.image)
                                        : process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + brand.image
                                    }
                                alt="Uploaded" 
                                className="w-16 h-16 object-cover rounded-lg" 
                              />
                            ) : (
                              <div className="text-gray-400 text-center text-xs">
                                <div>Click or drag</div>
                              </div>
                            )}
                          </label>
                        </div>
                      </td>
                      <td className="text-xs border">
                        <input
                          type="text"
                          value={brand.name}
                          onChange={(e) => handleInputChange(e, index, 'name')}
                          className="outline-blue-500 text-sm w-full h-full p-2 bg-transparent rounded-md 
                                    hover:border-blue-500 hover:ring-1 hover:ring-blue-500 hover:ring-opacity-90"
                        />
                      </td>
                      <td className="text-xs border">
                        <input
                          type="text"
                          value={brand.video}
                          onChange={(e) => handleInputChange(e, index, 'video')}
                          className="outline-blue-500 text-sm w-full h-full p-2 bg-transparent rounded-md 
                                    hover:border-blue-500 hover:ring-1 hover:ring-blue-500 hover:ring-opacity-90"
                        />
                      </td>
                      <td className="px-2 text-center">
                        <button
                          onClick={() => removeBrand(index)}
                          className="text-red-500 hover:text-red-700 focus:outline-none"
                        >
                          <FontAwesomeIcon className="w-3 h-3" icon={faTrash} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div>
              <button
                onClick={addBrand}
                className="text-blue-500 text-sm py-2 px-4"
              >
                <FontAwesomeIcon icon={faPlusCircle} className="mr-2" />
                Add Brand
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Brands;
